import { EventEmitter } from 'events';
import type TypedEmitter from 'typed-emitter';

type MessageEvent = {
  newNotification: (messageId: string) => void;
  notificationRead: (messageId: string) => void;
  allNotificationsRead: () => void;
};

const signalREventEmitter = new EventEmitter() as TypedEmitter<MessageEvent>;

export default signalREventEmitter;
